import React, { Component } from "react";
import "../common/print.css";
import { Modal, Button, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import { configuration } from "../../appConfig";
import { connect } from "react-redux";
import "../newstyle.css";
import CreatableSelect from 'react-select/creatable';
import { updateJsonData } from "../../redux/actions/updateJsonData";
import { token } from "../../appTokenConfig";

function findWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
});

class DetailedReportAuthorization extends Component {
    state = {
        selectedFile: "",
        order: {
            vinNumber: "",
            orderNumber: Math.round(Math.random() * 100000000),
            issuedOn: new Date(),
        },
        words: {},
        lang: "gb",
        Authorized: false,
        deAuthLoading: false,
        loading: false,
        jsonData: {},
        DetailedReportAuthorized: false,
        isDetailedReportAuthorizedKeyExists: false,
        modal: false,
        name: "",
        error: [],
        id: "",
        modal_dents: false,
        TotalDentCount: "",
        modal_Auth: false,
        ReportGenerated: false,
        customerCompany: '',
        isOpenWithEmailAuthorizationModal: false,
        isOpenWithoutEmailAuthorizationModal: false,
        isOpenDentsCountModal: false,
        sendEmail: "",
        subject: "",
        ccAccountsArr: [],
        optionArr: [],
        ccEmailOptionArr: [],
        ccAccountOptionArr: [],
        emailArr: [],
        ccEmailArr: [],
        isWithEmailModal: false,
        emailArrError: '',
        ccEmailArrError: '',
        ccAccountsArrError: '',
    };
    count = [];
    pageLanguage = {
        ch: "Seite",
        fr: "Page",
        en: "Page",
    };
    pageOfLanguage = {
        ch: "von",
        fr: "de",
        en: "of",
    };

    getLang = () => {
        const base_url = window.location.origin;
        Axios.get(`${base_url}/lang.json`).then((res) => {
            let lang = localStorage.getItem("lang");
            this.setState({ lang: lang });
            this.setState({ words: res.data });
        });
    };

    lang = (word) => {
        const { lang, words } = this.state;
        return words[word] ? words[word][lang] : word;
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        let obj = {}
        if (nextProps.fullData) {
            // obj.Authorized = nextProps.fullData.Authorized
            obj.fullData = nextProps.fullData
        }
        if (nextProps.lang !== prevState.lang) {
            obj.lang = nextProps.lang
        }

        return Object.keys(obj).length ? obj : null;
    }
    componentWillReceiveProps(nextProps, prevState) {
        if (nextProps.fullData) {
            this.setState({
                // Authorized: nextProps.fullData.Authorized,
                fullData: nextProps.fullData
            })
        }
    }
    async componentDidMount() {
        const selectedFile = localStorage.getItem("selectedFile");
        this.setState({ vinNumber: selectedFile });
        this.getData(selectedFile);
        this.getLang();
        this.getFallbackDetails();
        this.getInsuranceClientsEmails();
    }
    getData = async () => {
        const selectedFile = localStorage.getItem("selectedFile");
        const partnerId = localStorage.getItem("partnerId");
        Axios.get(`${configuration.getData}?vin=${selectedFile}&partnerId=${partnerId}`)
            .then((r) => {
                if (r.data) {
                    this.setState({
                        DetailedReportAuthorized: r.data && r.data.DetailedReportAuthorized ? r.data.DetailedReportAuthorized : false,
                        isDetailedReportAuthorizedKeyExists: r.data.hasOwnProperty("DetailedReportAuthorized"),
                        Authorized: r.data.Authorized, // Check if r.data.Authorized is being correctly retrieved
                        id: r.data.Authorized ? (r.data.DriveThrough == "1" ? "drive_in" : "drive_through") : "",
                        TotalDentCount: r.data.TotalDentCount ? r.data.TotalDentCount : "0",
                        ReportGenerated: r.data.ReportGenerated,
                        name: r.data.AuthorizedName,
                        customerCompany: r.data.CustomerCompany ? r.data.CustomerCompany : '',
                        isJSONLoading: false,
                        PreDamage: r.data.PreDamage,
                        ReportGeneratedStatus: r.data.hasOwnProperty('ReportGeneratedStatus') ? r.data.ReportGeneratedStatus : 'FAIL',
                        jsonData: r.data
                    }, () => {
                        this.checkStatus();
                    });
                }
            }).catch(error => {
                alert('An error occurred. Please try again.');
            });
    };

    checkStatus = () => {
        const { jsonData } = this.state;
        const isAnyOnecheck = jsonData.Dents && jsonData.Dents.some(item => (item.Replacing && item.Replacing == true) || (item.Preprints && item.Preprints == true));
        if (isAnyOnecheck) {
            Swal.fire({
                type: 'info',
                icon: 'info',
                title: this.lang('attention'),
                text: this.lang('The calculation report must be used for a combined repair!'),
                confirmButtonText: 'OK',
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.value) {
                    if (this.props.history) {
                        this.props.history.push('/DATswiss');
                    } else {
                        console.error('History is not defined');
                    }
                }
            })
            .catch(error => {
                console.error('Error in Swal:', error);
            });
        }
    }

    // internalStatus = async (vin) => {
    //     const url = configuration.internalStatus;
    //     let payload = {
    //         vin: vin,
    //         status: 3,
    //     }
    //     const headers = {
    //         Authorization: `Bearer ${token}`,
    //     };
    //     await Axios.post(url, payload, { headers })
    // }

    authorize = async () => {
        this.setState({
            modal_Auth: true
        })
        const { id } = this.state;
        var driveinid = id === "drive_in" ? 1 : 0
        const { fullData, subject, sendEmail } = this.state
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        const url1 =
            configuration.PostEditorChanges +
            `?partnerId=${partnerId}&vin=${vin}&TabViewUpdated=${false}`;

        this.setState({
            loading: true
        })
        let totalDents = 0;
        await fullData && fullData.Dents && fullData.Dents.length && fullData.Dents.map((row, i) => {
            if (row.Part === 'TrunkCover') {
                fullData.Dents[i]['A'] = fullData.Dents[i]['A'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'];
                fullData.Dents[i]['B'] = fullData.Dents[i]['B'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'];
                fullData.Dents[i]['C'] = fullData.Dents[i]['C'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'];
                fullData.Dents[i]['TotalDents'] = fullData.Dents[i]['A'] + fullData.Dents[i]['B'] + fullData.Dents[i]['C'];
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['TotalDents'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaMm'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaPx'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWa'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWb'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWc'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AW'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['Price'] = 0;
            }
            if (row.Part !== 'Trunk') {
                totalDents += (parseInt(row.A) ? parseInt(row.A) : 0) + (parseInt(row.B) ? parseInt(row.B) : 0) + (parseInt(row.C) ? parseInt(row.C) : 0);
            }
        })
        let payload1 = {
            "partnerId": partnerId,
            "vin": vin,
            "authorizer_name": this.state.name,
            "subject": subject,
            "report": "detailed",
            "send_email": localStorage.getItem("isSendEmail") || sendEmail,
            "report_type": "detailed"
        }
        this.setState({
            fullData: { ...this.state.fullData, 'TotalDentCount': totalDents }
        }, async () => {

            const url = configuration.generatePDF;
            await Axios.post(url1, { ...fullData, DetailedReportAuthorized: true, Authorized: false, DriveThrough: driveinid, ReportGenerated: false, AuthorizedName: this.state.name, ReportGeneratedStatus: 'PENDING' })
                .then(async (res) => {
                    await Axios.post(url, payload1).then((res) => {
                        this.state.fullData.Authorized = true
                        if (res.data.status === 200) {
                            // this.internalStatus(vin);
                            this.setState({
                                loading: false,
                                Authorized: true, //for updating local state instantly
                                DetailedReportAuthorized: true,
                                isDetailedReportAuthorizedKeyExists: true,
                                modal_Auth: false
                            });
                            Toast.fire({
                                type: "success",
                                title: "PDF generated successfully!",
                            });
                            this.props.updateJsonData(this.state.fullData);

                        } else if (res.data.status === 500) {
                            this.setState({
                                loading: false,
                                modal_Auth: false
                            })
                            // vin or partner Id missing
                            Toast.fire({
                                type: "error",
                                title: "Something went wrong!",
                            });
                        } else {
                            this.setState({
                                loading: false,
                                modal_Auth: false
                            })
                            Toast.fire({
                                type: "error",
                                title: "pdf generate failed",
                            });
                        }
                        // alert("data updated");
                    }).catch(err => {
                        this.setState({
                            loading: false,
                            modal_Auth: false
                        })
                        Toast.fire({
                            type: "error",
                            title: "pdf generate failed",
                        });
                    });
                })
        })
    }

    authorizedrivethrough = async () => {
        this.setState({
            modal_Auth: true
        })
        const { id } = this.state;
        var driveinid = id === "drive_in" ? 1 : 0
        // for get updated JSON
        // this.getData(localStorage.getItem("selectedFile"),"Authorized");
        const { fullData, subject, sendEmail } = this.state
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        const url1 =
            configuration.PostEditorChanges +
            `?partnerId=${partnerId}&vin=${vin}&TabViewUpdated=${false}`;

        this.setState({
            loading: true
        })

        let totalDents = 0;
        await fullData && fullData.Dents && fullData.Dents.length && fullData.Dents.map((row, i) => {
            if (row.Part === 'TrunkCover') {
                fullData.Dents[i]['A'] = fullData.Dents[i]['A'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'];
                fullData.Dents[i]['B'] = fullData.Dents[i]['B'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'];
                fullData.Dents[i]['C'] = fullData.Dents[i]['C'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'];
                fullData.Dents[i]['TotalDents'] = fullData.Dents[i]['A'] + fullData.Dents[i]['B'] + fullData.Dents[i]['C'];
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['TotalDents'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaMm'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaPx'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWa'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWb'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWc'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AW'] = 0;
                fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['Price'] = 0;
            }
            if (row.Part !== 'Trunk') {
                totalDents += (parseInt(row.A) ? parseInt(row.A) : 0) + (parseInt(row.B) ? parseInt(row.B) : 0) + (parseInt(row.C) ? parseInt(row.C) : 0);
            }
        })
        this.setState({
            fullData: { ...this.state.fullData, 'TotalDentCount': totalDents }
        }, async () => {
            let payload = {
                ...this.state.fullData,
                Authorized: true,
                DetailedReportAuthorized: true,
                AuthorizedName: this.state.name,
                DriveThrough: 0,
                // ReportGenerated : true,
                ReportGeneratedStatus: 'PENDING'
            }
            const url = configuration.automated_scripts;
            let payload1 = {
                "partnerId": partnerId,
                "vin": vin,
                "authorizer_name": this.state.name,
                "subject": subject,
                "report": "detailed",
                "send_email": localStorage.getItem("isSendEmail") || sendEmail,
                "report_type": "detailed"
            }
            await Axios.post(url1, { ...fullData, Authorized: false, DriveThrough: driveinid, ReportGenerated: false })
                .then(async (res) => {
                    await Axios.post(url, payload1)
                        .then(async (res) => {
                            // this.internalStatus(vin);
                            this.state.fullData.Authorized = true
                            if (res.status === 200) {
                                Axios.post(url1, payload)
                                    .then((res) => {
                                        this.setState({
                                            loading: false,
                                            Authorized: true, //for updating local state instantly
                                            DetailedReportAuthorized: true,
                                            isDetailedReportAuthorizedKeyExists: true,
                                            modal_Auth: false
                                        })
                                        Toast.fire({
                                            type: "success",
                                            // title: "PDF generated successfully!",
                                            title: this.lang("All reports are being generated. Please check All Scan Records page after sometime."),
                                        });
                                        this.props.updateJsonData(this.state.fullData);
                                    }).catch(err => {
                                        this.setState({
                                            loading: false,
                                            modal_Auth: false
                                        })
                                        // alert("Table update failed");
                                        Toast.fire({
                                            type: "error",
                                            title: "Table update failed",
                                        });
                                    });
                            } else if (res.data.status === 500) {
                                this.setState({
                                    loading: false,
                                    modal_Auth: false
                                })
                                // vin or partner Id missing
                                Toast.fire({
                                    type: "error",
                                    title: "Something went wrong!",
                                });
                            } else {
                                this.setState({
                                    loading: false,
                                    modal_Auth: false
                                })
                                Toast.fire({
                                    type: "error",
                                    title: "pdf generate failed",
                                });
                            }
                        }).catch(err => {
                        })
                }).catch(err => {
                })
        })
    }

    deAuthorize = () => {
        const { fullData } = this.state;
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        const url1 =
            configuration.PostEditorChanges +
            `?partnerId=${partnerId}&vin=${vin}&TabViewUpdated=${false}`;
        this.setState({
            deAuthLoading: true
        })
        this.state.fullData.Authorized = false
        this.state.id = ""
        let payload = {
            ...this.state.fullData,
            ...this.state.id,
            Authorized: false,
            DetailedReportAuthorized: false,
            ReportGenerated: false,
            AuthorizedName: this.state.name,
            ReportGeneratedStatus: 'PENDING'
        }
        Axios.post(url1, payload).then((res) => {
            Toast.fire({
                type: "success",
                title: "De-Authorize PDF successfully!",
            });
            this.setState({
                Authorized: false,
                deAuthLoading: false,
                DetailedReportAuthorized: false,
                id: "",
                // isDetailedReportAuthorizedKeyExists:true
            })
            this.getData();
            this.props.updateJsonData(this.state.fullData);
        }).catch(err => {
            this.setState({
                deAuthLoading: false
            })
            alert("Table update failed");
        });
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSave = () => {
        const { name, id, isWithEmailModal } = this.state;
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        let error = [];
        if (name.trim() == "") {
            error.push("Please enter your name")
        }
        if (error.length) {
            this.setState({
                error: error,
                modal: true
            })
        } else {
            this.setState({
                error: [],
            })
        }
        if (id == "drive_in") {
            const url = configuration.authorizernamestore + `?partnerId=${partnerId}&vin=${vin}&name=${name}&drive_type=${"drive_in"}`;
            Axios.post(url).then((res) => {
                if (res.data.status === 200) {
                    // if (isWithEmailModal) {
                        this.updateEmailsInsurance();
                    // }
                    if (!error.length) {
                        window.history.pushState(null, "", window.location.href);
                        window.onpopstate = function () {
                            window.history.pushState(null, "", window.location.href);
                        };
                        this.authorize();
                        this.setState({
                            isAuthorizeLoader: false
                        }, () => this.toggleModal(
                            isWithEmailModal
                                ? "isOpenWithEmailAuthorizationModal"
                                : "isOpenWithoutEmailAuthorizationModal"
                        ))
                    }
                }
            })
        } else {
            if (!error.length) {
                if (isWithEmailModal) {
                    this.updateEmailsInsurance();
                }
                window.history.pushState(null, "", window.location.href);
                window.onpopstate = function () {
                    window.history.pushState(null, "", window.location.href);
                };
                this.authorizedrivethrough();
                this.setState({
                    isAuthorizeLoader: false
                }, () => this.toggleModal(
                    isWithEmailModal
                        ? "isOpenWithEmailAuthorizationModal"
                        : "isOpenWithoutEmailAuthorizationModal"
                ))
            }
        }
    }

    toggleModal = (modalName) => {
        this.setState({
            [modalName]: !this.state[modalName],
        });
    };

    mapDataToOptions = (data, key) => {
        return (
        //     (data &&
        //         data[key] &&
        //         data[key].map((item) => ({ value: item, label: item }))) ||
        //     []
        // );
        (data &&
            // data[key].length &&
            Array.isArray(data[key]) && data[key] &&
            data[key].map((item) => ({ value: item, label: item }))) ||
        []
    );
    };

    getInsuranceClientsEmails = () => {
        const partnerId = localStorage.getItem("partnerId");
        const url = configuration.getInsuranceEmails + "?partnerId=" + partnerId;
        Axios.get(url).then((res) => {
            if (res.data.data) {
                const { data } = res.data;
                let defaultName =
                    data && data.Emails && data.Emails.DefaultAuthorizerName
                        ? data.Emails.DefaultAuthorizerName
                        : "";
                let sendEmailDefault =
                data && data.Emails && data.Emails.SendEmailByDefault && data.Emails.SendEmailByDefault == "no" ? false : true;

                let emailResponse = this.mapDataToOptions(data && data.Emails, "to") || [];
                let emailResponseDefault =
                    this.mapDataToOptions(data && data.Emails, "toEmailDefault") || [];
                let emailResponseCC = this.mapDataToOptions(data && data.Emails, "cc") || [];
                let emailResponseDefaultCC =
                    this.mapDataToOptions(data && data.Emails, "CCEmailDefault") || [];

                let accounts = this.mapDataToOptions(data && data.ccAccount, "CCaccount") || [];
                let accounts_default =
                    this.mapDataToOptions(data && data.ccAccount, "CCaccountDefault") || [];

                const { optionArr, ccEmailOptionArr } = this.state;
                this.setState({
                    // selectedOption : [...emailresponce],
                    authorizerName: defaultName[0],
                    sendEmail: sendEmailDefault,
                    emailArr: [...emailResponseDefault],
                    ccEmailArr: [...emailResponseDefaultCC],
                    ccAccountsArr: [...accounts_default],
                    optionArr: [...optionArr, ...emailResponse],
                    ccEmailOptionArr: [...ccEmailOptionArr, ...emailResponseCC],
                    ccAccountOptionArr: [...this.state.ccAccountOptionArr, ...accounts],
                });
            }
        });
    };

    getFallbackDetails = () => {
        const url =
            configuration.getFallbackDetails +
            `?partner_id=${localStorage.getItem("partnerId")}`;
        Axios
            .get(url)
            .then((res) => {
                if (res && res.data) {
                    this.setState({
                        isWithEmailModal: res.data.is_email == "1",
                        sendEmail:  res.data.is_email == "1" ? "yes" : "no"
                    });
                } else {
                    Toast.fire({
                        type: "error",
                        title: "Something went wrong! Please try again later.",
                    });
                }
            })
            .catch((err) => {
                Toast.fire({
                    type: "error",
                    title: "Something went wrong! Please try again later.",
                });
            });
    };

    toggleSendEmail = (e) => {
        this.setState({
            sendEmail: e.target.checked,
        });
    };

    updateEmailsInsurance = () => {
        const [partnerId, vin] = [
            localStorage.getItem("partnerId"),
            localStorage.getItem("selectedFile"),
        ];
        const { emailArr, ccEmailArr, sendEmail, ccAccountsArr, name } = this.state;

        const url = configuration.updateInsuranceEmails;

        const payload = {
            "vin": vin,
            "authorise_name": name,
            "partner_id": partnerId,
            "send_email": sendEmail,
            "emails": emailArr.map(email => ({ email: email.value })),
            "cc_emails": ccEmailArr.map(email => ({
                email: email.value,
            })),
            "cc_accounts": ccAccountsArr.map(email => ({
                email: email.value,
            }))
        };

        Axios
            .post(url, payload)
            .then((res) => {
                // if (res.status === 200) {
                //     Toast.fire({
                //         type: "success",
                //         title: res && res.data && res.data.message
                //     });
                // } else if (res.data.status === 500) {
                //     // vin or partner Id missing
                //     Toast.fire({
                //         type: "error",
                //         title: "Something went wrong! Please try again later.",
                //     });
                // } else {
                //     Toast.fire({
                //         type: "error",
                //         title: res && res.data && res.data.message,
                //     });
                // }
            })
            // .catch((err) => {
            //     Toast.fire({
            //         type: "error",
            //         title: "Something went wrong! Please try again later.",
            //     });
            // })
    };

    handleSelectChange = (value, name) => {
        const isValidEmail = (email) => {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(String(email).toLowerCase());
        };
        if (name === "emailArr" || name === "ccEmailArr") {
            let errorKey = name + 'Error';
            if (Array.isArray(value)) {
                const isValid = value.every(email => isValidEmail(email.value));
                if (!isValid) {
                    this.setState({ [errorKey]: "Invalid email address detected!" });
                    setTimeout(() => {
                        // Clear error message after 3 seconds
                        this.setState({ [errorKey]: '' });
                    }, 3000);
                    return;
                }
            } else {
                if (!isValidEmail(value.value)) {
                    this.setState({ [errorKey]: "Invalid email address detected!" });
                    setTimeout(() => {
                        // Clear error message after 3 seconds
                        this.setState({ [errorKey]: '' });
                    }, 3000);
                    return;
                }
            }
        }
        this.setState({ [name]: value });
    };

    render() {
        const {
            jsonData,
            ReportGeneratedStatus,
            Authorized,
            DetailedReportAuthorized,
            isOpenWithEmailAuthorizationModal,
            isOpenWithoutEmailAuthorizationModal,
            isOpenDentsCountModal,
            error,
            optionArr,
            ccEmailOptionArr,
            ccEmailArr,
            subject,
            emailArr,
            sendEmail,
            ccAccountsArr,
            ccAccountOptionArr,
            isWithEmailModal,
            emailArrError,
            ccEmailArrError,
            ccAccountsArrError,
            isDetailedReportAuthorizedKeyExists
        } = this.state;
        return (
            <>
                {/* <button
                    id="drive_in"
                    className={`glass btn btn-lg  ${this.state.Authorized && this.state.id == "drive_in" ? 'btn-success' : 'btn-danger'} mr-1`}
                    disabled={this.state.loading || this.state.Authorized || (this.state.id == "drive_through" && this.state.Authorized)}
                    // onClick={this.authorize}>
                    // onClick={() => this.setState({modal : true, id : "drive_in"})}
                    // onClick={() => this.state.TotalDentCount == 0 ? this.setState({ modal_dents: true, id: "drive_in" }) : this.setState({ modal: true, id: "drive_in" })}
                    onClick={() => {
                        this.setState({
                            id: "drive_in"
                        });
                        this.state.TotalDentCount == 0
                            ? this.toggleModal("isOpenDentsCountModal")
                            : this.toggleModal(
                                isWithEmailModal
                                    ? "isOpenWithEmailAuthorizationModal"
                                    : "isOpenWithoutEmailAuthorizationModal"
                            );
                    }}
                >
                    {this.state.loading && this.state.id == "drive_in" ?
                        <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                            <span className="sr-only">Loading...</span>
                        </div>
                        :
                        <i className="fa fa-print" />
                    }
                    &nbsp; {this.lang("Authorize PDF Drive-In")}
                </button> */}

                {/* {isDetailedReportAuthorizedKeyExists && Authorized && (ReportGeneratedStatus !== 'PENDING') ? (
                    <button className={`glass btn mx-3 btn-lg btn-danger mr-1`}
                        disabled={!Authorized || Authorized && !DetailedReportAuthorized}
                        onClick={() => this.deAuthorize()}>
                        {this.state.deAuthLoading ?
                            <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                                <span className="sr-only">Loading...</span>
                            </div>
                            :
                            <i className="fa fa-print" />
                        }
                        &nbsp; {this.lang("De-Authorize PDF")}
                    </button>
                ) : ''} */}

                <Modal
                    isOpen={isOpenWithoutEmailAuthorizationModal}
                    className="authorizer_name_modal"
                    backdrop="static"
                    toggle={() =>
                        this.toggleModal("isOpenWithoutEmailAuthorizationModal")
                    }
                >
                    <ModalHeader className="align-item-center">
                        {this.lang("Authorizer name")}
                    </ModalHeader>
                    <ModalBody>
                        <form>
                            <div className="form_group">
                                <input className="form-control" placeholder={this.lang("Authorizer name")} type="text"
                                    name="name"
                                    value={this.state.name}
                                    onChange={(e) => this.handleChange(e)}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault()
                                            this.handleSave()
                                        }
                                    }}
                                />
                                {this.state.error.includes('Please enter your name') && <span style={{ color: "red" }}>{this.lang("Please enter your name")}</span>}
                                
                                {
                                    localStorage.getItem("client") !== "SWISS" ?
                                <div className="form_group mb-2 mt-2">
                                    <label className="name mb-2">{this.lang("CC Accounts")}</label>
                                    <CreatableSelect
                                        className="email_address_selection"
                                        onChange={(value) => this.handleSelectChange(value, "ccAccountsArr")}
                                        value={ccAccountsArr}
                                        isMulti
                                        options={ccAccountOptionArr}
                                    />
                                </div> 
                                : 
                                ""
                                }
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button
                                color="secondary"
                                className="btn btn-md p-2 mr-2"
                                onClick={() =>
                                    this.toggleModal("isOpenWithoutEmailAuthorizationModal")
                                }
                            >
                                {" "}
                                {this.lang("Cancel")}{" "}
                            </Button>
                            <Button
                                color="secondary"
                                className="btn btn-md p-2 btn-danger"
                                onClick={() => this.handleSave()}
                            >
                                {" "}
                                {this.lang("Save")}{" "}
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>

                {/* With Email Authorizer PDF Modal*/}
                <Modal
                    size="lg"
                    isOpen={isOpenWithEmailAuthorizationModal}
                    className="authorizer_emailsend_modal"
                    backdrop="static"
                    toggle={() => this.toggleModal("isOpenWithEmailAuthorizationModal")}
                >
                    <ModalBody>
                        <form>
                            <div className="form_group mb-2">
                                <label className="mb-1">{this.lang("Authorizer Name")}</label>
                                <input
                                    className="form-control"
                                    placeholder={this.lang("Authorizer Name")}
                                    type="text"
                                    name="name"
                                    value={this.state.name}
                                    onChange={(e) => this.handleChange(e)}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            this.handleSave();
                                        }
                                    }}
                                />
                                {error.includes("#emptyAuthorizerName") && (
                                    <span style={{ color: "red" }}>
                                        {this.lang("Please enter your name")}
                                    </span>
                                )}
                            </div>
                            <div className="form_group mb-2">
                                <label className="mb-1">{this.lang("Subject")}</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="subject"
                                    value={subject}
                                    onChange={(e) => this.handleChange(e)}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            this.handleSave();
                                        }
                                    }}
                                />
                            </div>
                            <div className="form_group mb-2">
                                <div className="d-flex justify-content-between mb-2 align-items-center">
                                    <div>
                                        <label className="mb-0">{this.lang("Email Address")}</label>
                                    </div>
                                    {/* <div className="main-wrapper-switch-lab-modal">
                                        <div className="admin-list report_switch_wrapper">
                                            <label className="name">{this.lang("Send Email")}</label>
                                            <label className="switch">
                                                <input
                                                    className="switch-input"
                                                    type="checkbox"
                                                    name="sendEmail"
                                                    id="sendEmail"
                                                    value={sendEmail}
                                                    onClick={(e) => this.toggleSendEmail(e)}
                                                    checked={sendEmail}
                                                />
                                                <span
                                                    className="switch-label"
                                                    data-on={this.lang("Yes")}
                                                    data-off={this.lang("No")}
                                                ></span>
                                                <span className="switch-handle"></span>
                                            </label>
                                        </div>
                                    </div> */}
                                </div>
                                <CreatableSelect
                                    className="email_address_selection"
                                    onChange={(value) => this.handleSelectChange(value, "emailArr")}
                                    value={emailArr}
                                    isMulti
                                    options={optionArr}
                                    inputProps={{
                                        pattern: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
                                        title: "Please enter a valid email address"
                                    }}
                                />

                                {emailArrError && <div className="error" style={{ color: "red" }}>{emailArrError}</div>}
                                <div className="form_group mb-2 mt-2">
                                    <label className="name mb-2">{this.lang("CC Email Address")}</label>
                                    <CreatableSelect
                                        className="email_address_selection"
                                        onChange={(value) => this.handleSelectChange(value, "ccEmailArr")}
                                        value={ccEmailArr}
                                        isMulti
                                        options={ccEmailOptionArr}
                                        inputProps={{
                                            pattern: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
                                            title: "Please enter a valid email address"
                                        }}
                                    />
                                </div>
                                {ccEmailArrError && <div className="error" style={{ color: "red" }}>{ccEmailArrError}</div>}
                                
                                {
                                    localStorage.getItem("client") !== "SWISS" ?
                                <div className="form_group mb-2 mt-2">
                                    <label className="name mb-2">{this.lang("CC Accounts")}</label>
                                    <CreatableSelect
                                        className="email_address_selection"
                                        onChange={(value) => this.handleSelectChange(value, "ccAccountsArr")}
                                        value={ccAccountsArr}
                                        isMulti
                                        options={ccAccountOptionArr}
                                        inputProps={{
                                            pattern: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
                                            title: "Please enter a valid email address"
                                        }}
                                    />
                                </div>
                                : 
                                ""}
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            <Button
                                className="btn btn-cancel  p-2 mr-2"
                                onClick={() =>
                                    this.toggleModal("isOpenWithEmailAuthorizationModal")
                                }
                            >
                                {" "}
                                {this.lang("Cancel")}{" "}
                            </Button>
                            <Button
                                className="btn p-2 btn-danger"
                                onClick={() => {
                                    this.handleSave();
                                }}
                            >
                                {" "}
                                {this.lang("Save")}{" "}
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>

                {/* Dent Count Modal */}
                <Modal
                    size="md"
                    isOpen={isOpenDentsCountModal}
                    className="dent_zero_modal"
                    backdrop="static"
                    toggle={() => this.toggleModal("isOpenDentsCountModal")}
                >
                    <ModalBody className="text-center">
                        <p className="mb-3 text-message-extra-image">
                            <b>
                                {this.lang(
                                    "The total number of dents is 0. Would you still like to authorize.",
                                )}
                            </b>
                        </p>
                        <Button
                            className="btn btn-danger p-2 mr-2"
                            onClick={() => {
                                const modalName = isWithEmailModal ? "isOpenWithEmailAuthorizationModal" : "isOpenWithoutEmailAuthorizationModal";
                                this.setState({
                                    isOpenDentsCountModal: false,
                                    [modalName]: !this.state[modalName]
                                });
                            }
                            }
                        >
                            {this.lang("Yes")}
                        </Button>
                        <Button
                            className="btn btn-cancel p-2"
                            onClick={() => this.toggleModal("isOpenDentsCountModal")}
                        >
                            {this.lang("No")}
                        </Button>
                    </ModalBody>
                </Modal>

                <Modal centered size="lg" isOpen={this.state.modal_Auth} className="authorise_modalpopup" backdrop="static"
                    toggle={() => this.setState({ modal_Auth: false })}>
                    <ModalBody className="text-center">
                        <p className="mb-3 text-message-extra-image"><b>{this.lang("Please wait Authorization in progress")}<span className="dot-flashing"></span></b></p>
                    </ModalBody>
                </Modal>
            </>
        );
    }
}
const mapStateToProps = (props) => {
    return {
        lang: props.lang,
        fullData: props.jsonData
    };
};
export default connect(mapStateToProps, {
    updateJsonData
})(DetailedReportAuthorization);